export const EVENT_ACCESS_MODULES = [
  { key: "dashboard", label: "Dashboard", group: "General", alwaysOn: true },
  { key: "occasion-master", label: "Add Occasion", group: "Occasion Master" },
  { key: "guest-master", label: "Add Guest", group: "Guest Master" },
  { key: "guest-attendee", label: "Add Attendee", group: "Guest Master" },
  { key: "allocate-guest", label: "Allocate Guests", group: "Guest Master" },
  { key: "send-invites", label: "Send Invites", group: "Invites and RSVP" },
  { key: "track-invites", label: "RSVP", group: "Invites and RSVP" },
  { key: "seat-allocation", label: "Seat Allocation", group: "Operations" },
  { key: "hotel-master", label: "Hotel Master", group: "Operations" },
  { key: "travel-and-stay", label: "Travel & Stay", group: "Operations" },
  { key: "reports-guest-invites", label: "Guest & Invites", group: "Reports" },
  { key: "stay-reports", label: "Accommodation", group: "Reports" },
  { key: "reports-travel", label: "Travel", group: "Reports" },
  { key: "reports-seat", label: "Seat Allocation", group: "Reports" },
  { key: "lookup", label: "Lookup", group: "Admin" },
  { key: "event-user", label: "User Access", group: "Admin" },
];

const LEGACY_PAGE_MAP = {
  occasion: ["occasion-master"],
  guest: ["guest-master", "guest-attendee", "allocate-guest"],
  invites: ["send-invites", "track-invites"],
  reports: [
    "reports-guest-invites",
    "stay-reports",
    "reports-travel",
    "reports-seat",
  ],
  "reports-hotel-pricing": ["stay-reports"],
};

export const expandLegacyPages = (pages = []) => {
  const expanded = [];
  pages.forEach((key) => {
    const mapped = LEGACY_PAGE_MAP[key];
    if (mapped) expanded.push(...mapped);
    else expanded.push(key);
  });
  return [...new Set(expanded)];
};

/**
 * Returns true when the selected event may open this page.
 * Missing allowedPages = full access (legacy). Array = enforce.
 */
export const isSuperAdminUser = (user) =>
  Boolean(
    user?.isSuperAdmin ||
      user?.role === "superAdmin" ||
      user?.role === "Super Admin"
  );

export const canAccessModule = (selectedEvent, moduleKey, user) => {
  // Super Admin always has full sidebar / page access inside an event
  if (isSuperAdminUser(user)) return true;
  if (moduleKey === "dashboard") return true;
  const pages = selectedEvent?.allowedPages;
  if (!Array.isArray(pages)) return true;
  const normalized = expandLegacyPages(pages);
  return normalized.includes(moduleKey);
};

export const canAccessAny = (selectedEvent, moduleKeys, user) =>
  moduleKeys.some((key) => canAccessModule(selectedEvent, key, user));

/** Prefer selectedEvent.allowedPages; fall back to matching entry in events[]. */
export const resolveEventAccess = (selectedEvent, events = []) => {
  if (!selectedEvent) return null;
  if (Array.isArray(selectedEvent.allowedPages)) {
    return {
      ...selectedEvent,
      allowedPages: expandLegacyPages(selectedEvent.allowedPages),
    };
  }
  const match = (events || []).find(
    (event) => String(event.eventId) === String(selectedEvent.eventId)
  );
  if (match && Array.isArray(match.allowedPages)) {
    return {
      ...selectedEvent,
      allowedPages: expandLegacyPages(match.allowedPages),
    };
  }
  return selectedEvent;
};

export const groupAccessModules = (modules = EVENT_ACCESS_MODULES) => {
  const groups = [];
  const map = new Map();
  modules.forEach((module) => {
    const group = module.group || "Other";
    if (!map.has(group)) {
      const entry = { group, items: [] };
      map.set(group, entry);
      groups.push(entry);
    }
    map.get(group).items.push(module);
  });
  return groups;
};
